module.exports = __webpack_public_path__ + "MC.png?396cd4af4b0da536346f3192c9b4dc7e";